import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

type Task = { name: string; isCompleted: boolean };

@Injectable({
  providedIn: "root"
})
export class TaskStatusService {
  private tasksStatusSubject = new BehaviorSubject<Map<string, boolean>>(new Map());

  tasksStatus$: Observable<Map<string, boolean>> = this.tasksStatusSubject.asObservable();

  private tasksStatus: Map<string, boolean> = new Map();

  updateTaskStatus(taskName: string, isCompleted: boolean) {
    this.tasksStatus.set(taskName, isCompleted);
    this.tasksStatusSubject.next(this.tasksStatus);
  }

  initTasks(tasks: Task[]) {
    this.tasksStatus = new Map(tasks.map((t) => [t.name, t.isCompleted]));
    this.tasksStatusSubject.next(this.tasksStatus);
  }
}
